import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as csx from 'csstips';
import * as typestyle from 'typestyle';
import * as gls from '../../ap/layout/gls';
import * as styles from '../../ap/base/styles';
import { ButtonStyles } from '../../ap/base/button';
import { ProgressBar } from "../../ap/base/loader";
import { DisplayValue, DisplayValueSelectField } from '../../ap/fields/selectField';
import { FieldState } from '../../ap/fields/field';
import { SingleFileDropzone, uploadFile, DropzoneStyles } from '../components/dropzone';
import * as utils from '../../ap/utils/utils';
import * as text from '../../ap/base/text';
import { Hr } from '../../ap/base/hr';
import { PrimaryButton } from '../../ap/base/button';
import { Anchor, AnchorStyles } from '../../ap/base/anchor';
import { DocumentName, DocumentNameToDisplay, allowedFileExtensions } from './documentSightingConfig';
import { FieldStyles } from '../../ap/fields/field';

declare var propertyTransferBaseUrl: string;

const images = {
  pdf: propertyTransferBaseUrl + '/images/pdf.jpeg',
}

type Image = {
  file: File
}
interface Props {
  onAdd: (image: Image) => void,
  transactionId: string,
  text: string,
  id?: string
}
interface State {
}

export class DocumentImageDropzone extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return <gls.Content>
      <SingleFileDropzone
        id={this.props.id}
        validators={[
          (file) => {
            if (!allowedFileExtensions.some(ext => file.name.toLowerCase().endsWith('.' + ext))) {
              return `Must be an image file: (${allowedFileExtensions.join(', ')})`;
            }
          }
        ]}
        contents={
          <button id={this.props.id + "button"} className={ButtonStyles.secondaryClassName}>{this.props.text}</button>
        }

        onFileAdded={
          (file) => {
            this.props.onAdd({
              file,
            });
          }
        }
        />
    </gls.Content>;
  }
}

/**
 * Displays a file as an img
 */
class FileAsImage extends React.Component<{ file: File }, {}>{
  componentDidMount() {
      var reader = new FileReader();
      reader.onload = (e) => { this.ctrls.img.src = (e.target as any).result; };
      reader.readAsDataURL(this.props.file);
  }
  ctrls: {
    img?: HTMLImageElement
  } = {}
  render() {
    if (this.props.file.name.toLowerCase().endsWith('pdf')  ) {
      return <img src={images.pdf} width="100px" />
    } else {
      return <img style={{
        maxHeight: '300px',
        maxWidth: '100%',
        /** Preserve aspect ratio */
        height: 'auto', width: 'auto'
      }} ref={(img) => { this.ctrls.img = img; }} />
    }
  }
}

/**
 * If you want to show an image file with the same kind of styling as a dropzone
 */
export class DropzoneLikeImageFileDisplay extends React.Component<{
  file: File,
  onRemove: () => any,
  errorMessage?: string,
  progress: number,
  uploaded: boolean,
}, {}> {
  render() {
    const hasError = !!this.props.errorMessage;
    return <div className={DropzoneStyles.rootClassName}>
      <div className={DropzoneStyles.buttonClassName} style={
        hasError ? { borderColor: styles.colors.errorRed }
          : this.props.uploaded ? { borderColor: "rgba(6, 122, 61, 0.53)" }
            : {}}>
        <gls.ContentVerticalCentered>
          {
            hasError && <div>
              <div className={FieldStyles.errorTextClassName}>
                {this.props.errorMessage}
              </div>
              <gls.SmallVerticalSpace space={styles.spacing.verticalBetweenFields} />
            </div>
          }
          <FileAsImage file={this.props.file} />
          <gls.SmallVerticalSpace space={styles.spacing.verticalBetweenFields} />
          {
            !!this.props.progress
              ? <ProgressBar percent={this.props.progress} />
              : <Anchor onClick={this.props.onRemove}><span>Remove</span></Anchor>
          }
        </gls.ContentVerticalCentered>
      </div>
    </div>
  }
}

